export const Truck = () => {
    return (
        <svg width="817" height="349" viewBox="0 0 817 349" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M514.5 165.484V93.5379C514.411 92.0751 514.196 89.949 513.638 87.5304C513.169 85.5019 511.311 78.3436 506.291 74.0623C503.147 71.3803 500.148 71 498.5 71V83.9415C500.091 84.6339 502.513 86.1163 504.167 89.5492C505.765 92.8553 505.948 96.4929 506.012 98.2483C506.31 106.294 506.494 119.804 506.297 165.484V277.306L503.514 287H511.044L514.494 276.692V165.475L514.5 165.484Z"
                fill="#1B211E"
                stroke="#259975"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <g clipPath="url(#clip0_3055_759)">
                <path
                    d="M143.012 337.5L159.001 331.058L163.144 280.632L154.565 281.441L143.012 299.378L142.822 331.698V334.5L143.012 337.5Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M309.712 311.874C309.712 331.175 299.065 346.82 279.762 346.82C260.459 346.82 239.811 331.175 239.811 311.874C239.811 298.922 271.292 294.661 292 299.093"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M227.902 311.874C227.268 326.964 217.292 346.821 195.952 346.821C150 346.821 156.105 324.371 159.001 311.874C163.476 292.564 213.2 283.216 225.133 299.241C228.253 303.433 228.048 308.463 227.902 311.874Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M445.654 104.273L498.523 127.892C501.633 129.286 504.363 131.402 506.479 134.073L511.849 144.372L499.5 143.5C450.862 126.968 403.638 113.532 355 97.0001C354 95.5001 348.635 92.9757 361.5 94.0001C372.935 94.9106 396.869 94.6763 408.306 95.5845C414.643 96.0914 439.853 101.671 445.654 104.264V104.273Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M299.417 286.393H537.769C538.143 286.393 538.485 286.185 538.657 285.854L553.307 257.586C553.356 257.491 553.421 257.404 553.498 257.329L566.018 245.156C566.56 244.629 567.468 244.871 567.676 245.598L577.217 278.932M541.5 313.873H313.5"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M354.402 93.7944V154.241H503.252L496.934 136.646C496.778 136.227 496.476 135.876 496.076 135.681C455.042 115.24 410.947 101.612 365.536 95.3346L354.412 93.7944H354.402Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M354.402 275.7H331.307L323.03 264.295L314.48 256.311V93.7944H354.402V275.7Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M468.184 154.241V266.011L463.904 275.7H354.402V154.241H468.184Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M464.5 275.7H555.672L576.5 272.5V252.5V247.5L561.844 196.684L550.876 183.944L536.818 144.241H471.78V261.478L464.5 275.7Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M485.34 157.86H527.163C528.499 157.86 529.678 158.718 530.098 159.975L542.957 198.869C543.064 199.181 543.113 199.513 543.113 199.834V262.24C543.113 263.946 541.728 265.321 540.032 265.321H485.349C483.643 265.321 482.269 263.937 482.269 262.24V160.94C482.269 159.234 483.653 157.86 485.349 157.86H485.34Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M348.241 275.7V282.016L554.2 280.739V275.7H348.241Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M467.691 291H347.309C346.862 291 346.5 291.338 346.5 291.754V327.246C346.5 327.662 346.862 328 347.309 328H467.691C468.138 328 468.5 327.662 468.5 327.246V291.754C468.5 291.338 468.138 291 467.691 291Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path d="M363.305 291.183V328.183" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path d="M368.305 291.183V328.183" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path d="M455.305 291.183V328.183" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path d="M460.305 291.183V328.183" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path d="M541.5 300H475.5V314H541.5V300Z" fill="#1B211E" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path
                    d="M475.51 319H541.5L540.741 323.987C540.653 324.571 540.264 325 539.816 325H476.969C476.502 325 476.103 324.545 476.035 323.922L475.5 319.013L475.51 319Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M475.271 281.5V295.176H538.38L544.884 280.792L475.271 281.5Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M314.537 333.5C314.634 320.643 314.439 312.372 314.537 299.504C314.547 298.023 314.098 296.57 313.24 295.362L302.282 279.833C301.844 279.219 301.142 278.849 300.391 278.849H150.805C149.956 279.034 149.352 279.346 148.787 279.96L143.23 288.714C139.486 294.611 137.497 301.454 137.497 308.443L137.497 337.609C137.497 337.804 137.653 337.96 137.848 337.96H142.225C142.586 337.96 142.878 337.667 142.878 337.307L142.879 311.153C142.879 303.443 145.15 295.907 149.411 289.484L152.335 285.068C152.988 284.385 156.7 283.927 157.617 283.859L297.915 285.029C304.749 293.47 308.707 303.871 309.204 314.711L310 339H314.5L314.537 333.5Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M269.956 278.858H184.163V299.797H269.956V278.858Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
                <path
                    d="M269.956 295.508H184.163V306.786H269.956V295.508Z"
                    fill="#0D120F"
                    stroke="#259975"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
                <path
                    d="M184.163 346.821C203.466 346.821 219.114 331.175 219.114 311.874C219.114 292.574 203.466 276.928 184.163 276.928C164.861 276.928 149.213 292.574 149.213 311.874C149.213 331.175 164.861 346.821 184.163 346.821Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M184.163 331.058C194.76 331.058 203.35 322.469 203.35 311.874C203.35 301.279 194.76 292.69 184.163 292.69C173.567 292.69 164.977 301.279 164.977 311.874C164.977 322.469 173.567 331.058 184.163 331.058Z"
                    fill="#2D3330"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M184.163 317.567C187.308 317.567 189.857 315.018 189.857 311.874C189.857 308.73 187.308 306.182 184.163 306.182C181.019 306.182 178.47 308.73 178.47 311.874C178.47 315.018 181.019 317.567 184.163 317.567Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M267.235 346.821C286.538 346.821 302.186 331.175 302.186 311.874C302.186 292.574 286.538 276.928 267.235 276.928C247.933 276.928 232.285 292.574 232.285 311.874C232.285 331.175 247.933 346.821 267.235 346.821Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M267.235 331.058C277.832 331.058 286.422 322.469 286.422 311.874C286.422 301.279 277.832 292.69 267.235 292.69C256.639 292.69 248.049 301.279 248.049 311.874C248.049 322.469 256.639 331.058 267.235 331.058Z"
                    fill="#2D3330"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M267.235 317.567C270.38 317.567 272.929 315.018 272.929 311.874C272.929 308.73 270.38 306.182 267.235 306.182C264.091 306.182 261.542 308.73 261.542 311.874C261.542 315.018 264.091 317.567 267.235 317.567Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M413.695 166.728H371.53C369.872 166.728 368.527 168.072 368.527 169.73V224.055C368.527 225.714 369.872 227.058 371.53 227.058H413.695C415.353 227.058 416.698 225.714 416.698 224.055V169.73C416.698 168.072 415.353 166.728 413.695 166.728Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M413.669 237H371.331C369.767 237 368.5 238.114 368.5 239.489V262.511C368.5 263.886 369.767 265 371.331 265H413.669C415.233 265 416.5 263.886 416.5 262.511V239.489C416.5 238.114 415.233 237 413.669 237Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M492.283 165.778H522.527C523.58 165.778 524.516 166.47 524.828 167.474L534.542 198.616C535.01 200.156 533.86 201.715 532.241 201.715H492.283C490.957 201.715 489.884 200.643 489.884 199.317V168.176C489.884 166.851 490.957 165.778 492.283 165.778Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M471.78 154.241V82.3282C471.644 80.866 471.312 78.7409 470.454 76.3235C469.733 74.2959 466.876 67.1409 459.155 62.8616C454.319 60.1809 449.708 59.8008 447.173 59.8008V72.7362C449.62 73.4283 453.345 74.91 455.889 78.3413C458.346 81.6458 458.629 85.2818 458.726 87.0364C459.184 95.0784 459.467 108.582 459.165 154.241V266.011L454.885 275.7H466.466L471.77 265.396V154.231L471.78 154.241Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M587 347.5C567.697 347.5 553.302 330.288 553.302 310.988C553.302 296.569 565.035 284.191 577.5 278.851"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M631.473 287.294C630.089 285.608 618.345 271.897 600.436 272.033C597.989 272.053 580.727 273.452 570.218 287.109C562.36 297.315 561.633 309.554 561.809 312.703C554.701 312.703 548.585 312.693 541.478 312.684C541.507 308.687 542.072 289.415 557.525 273.604C559.806 271.274 574.927 256.302 598.247 256.692C630.224 257.228 646.924 286.14 647.645 287.436C641.591 287.729 637.537 287.012 631.483 287.304L631.473 287.294Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M635.303 310.987C635.303 330.288 619.656 345.933 600.352 345.933C599.933 345.933 599.514 345.933 599.095 345.914C580.376 345.251 565.402 329.869 565.402 310.987C565.402 292.106 581.049 276.041 600.352 276.041C619.656 276.041 635.303 291.686 635.303 310.987Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M600.352 330.171C610.949 330.171 619.539 321.583 619.539 310.988C619.539 300.393 610.949 291.804 600.352 291.804C589.756 291.804 581.166 300.393 581.166 310.988C581.166 321.583 589.756 330.171 600.352 330.171Z"
                    fill="#2D3330"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M600.352 316.68C603.497 316.68 606.046 314.131 606.046 310.987C606.046 307.843 603.497 305.294 600.352 305.294C597.208 305.294 594.659 307.843 594.659 310.987C594.659 314.131 597.208 316.68 600.352 316.68Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path d="M-6.50116 348H855.501" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path d="M743.5 253H737.5V339H743.5V253Z" fill="#1B211E" stroke="#259975" strokeWidth="2" strokeMiterlimit="10" />
                <path
                    d="M741.666 213.206L765.035 251.203C765.473 251.915 764.957 252.822 764.128 252.822H717.391C716.562 252.822 716.045 251.905 716.484 251.203L739.853 213.206C740.272 212.534 741.247 212.534 741.666 213.206Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M740.477 223.568C740.613 223.354 740.925 223.354 741.052 223.568L746.404 232.263L749.885 237.927L755.208 246.573C755.344 246.797 755.188 247.09 754.915 247.09H726.613C726.35 247.09 726.185 246.797 726.321 246.573L731.644 237.927L735.124 232.263L740.477 223.568Z"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M726.5 348L729.873 338H751.611L755.5 348H726.5Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path d="M314.5 339H322V314.5" stroke="#259975" strokeWidth="2" />
                <path
                    d="M616.849 260.53C616.849 260.53 624.958 251.063 626.422 250.156C627.886 249.249 635.676 237.138 635.615 235.462C635.553 233.787 622.266 218.452 622.266 218.452C622.266 218.452 618.776 215.823 616.912 215.341C615.049 214.86 599.786 217.81 599.786 217.81L582.599 218.604L567.5 215.104L572 230.727C572 230.727 613.759 231.435 616.001 231.331C618.243 231.228 623.095 241.076 623.904 242.718C624.713 244.359 620.382 248.756 620.382 248.756L613.02 258.682"
                    stroke="#259975"
                    strokeWidth="2"
                />
                <path
                    d="M569.627 221.444L583.559 222.157L600.863 222.137C600.863 222.137 615.135 221.479 615.886 221.444C616.637 221.409 622.066 225.835 622.066 225.835"
                    stroke="#259975"
                    strokeWidth="2"
                />
                <path
                    d="M588.063 230.953L584.488 230.627C584.532 230.201 584.585 229.666 584.635 229.071C584.758 227.62 584.87 225.773 584.811 224.302C584.754 222.887 584.509 221.128 584.285 219.749C584.207 219.268 584.131 218.828 584.064 218.458L587.587 218.295C587.66 218.704 587.752 219.235 587.848 219.83C588.066 221.196 588.295 222.861 588.359 224.156C588.433 225.643 588.337 227.577 588.217 229.167C588.165 229.859 588.109 230.477 588.063 230.953Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                />
                <path
                    d="M588.463 219.565C588.381 219.08 588.301 218.637 588.232 218.265L590.733 218.15L594.694 217.967C594.786 218.315 594.877 218.828 594.961 219.48C595.142 220.889 595.269 222.796 595.324 224.723C595.38 226.651 595.364 228.564 595.265 229.986C595.219 230.635 595.159 231.149 595.089 231.505C594.249 231.479 592.751 231.387 591.269 231.285C590.329 231.22 589.425 231.154 588.756 231.104C588.729 231.102 588.703 231.1 588.677 231.098C588.728 230.622 588.79 230.012 588.848 229.331C588.982 227.751 589.103 225.742 589.025 224.144C588.956 222.721 588.698 220.952 588.463 219.565Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                />
                <path
                    d="M619.292 236.368L622.095 240.557C622.095 240.557 623.422 239.579 624.94 237.939C626.881 235.841 628.019 234.535 629.141 231.744C629.91 229.828 630.457 227.396 630.457 227.396L626.617 223.286"
                    stroke="#259975"
                    strokeWidth="2"
                />
                <path
                    d="M622.39 224.484C622.961 221.666 622.957 219.559 622.957 219.559L626.84 223.462C626.84 223.462 626.768 227.411 625.586 230.052C624.944 231.485 624.403 232.193 623.465 233.416C621.59 235.862 619.566 236.825 619.566 236.825L617.584 234.008C617.584 234.008 618.318 232.979 618.925 231.993C620.53 229.385 621.768 227.549 622.39 224.484Z"
                    fill="#1B211E"
                    stroke="#259975"
                    strokeWidth="2"
                />
            </g>
            <path
                d="M547.247 129.901C549.466 127.673 551.525 126.806 552.966 126.417C555.712 125.684 558.168 126.208 558.751 124.96C559.107 124.207 558.559 123.279 558.321 122.858C555.91 118.635 553.751 113.771 553.094 111.891C552.718 110.83 550.9 105.643 553.482 101.403C555.556 98.0094 559.366 96.9872 560.663 96.7009"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M566.926 98.2223C567.707 95.5536 568.654 93.4939 569.397 92.0651C571.334 88.3637 572.406 88.0262 572.93 87.9505C574.338 87.7386 575.524 88.8311 575.695 88.9913C577.134 90.3096 577.029 92.1661 577.008 92.4204"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M587.636 85.8709C588.274 85.6939 589.633 85.2007 590.576 83.9019C590.847 83.5322 591.711 82.2262 591.44 79.6017C591.01 75.4122 588.389 74.6203 587.219 71.0695C585.951 67.1904 587.167 62.3129 590.029 59.1664C593.268 55.6174 597.741 55.2074 598.705 55.1466C601.664 54.9521 604.463 55.8259 604.463 55.8259C606.493 56.4518 606.784 57.008 608.102 57.0428C610.201 57.0911 612.499 55.7771 613.659 53.6616C615.03 51.1686 614.227 48.6689 614.086 48.2444"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M608.168 40.3712C607.819 38.6661 607.55 36.383 607.745 33.714C607.867 32.0714 608.151 30.6284 608.472 29.4182"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M599.262 23.3052C600.298 21.8766 602.597 19.1191 606.533 17.1955C610.796 15.1149 614.621 15.1651 615.882 15.2213C620.649 15.4357 624.049 17.4017 625.525 18.3774"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M661.526 16.1307C660.965 15.3786 659.91 14.1648 658.212 13.2451C657.557 12.896 654.164 11.1443 650.531 12.5021C649.538 12.8759 647.64 13.5819 647.071 15.278C646.378 17.3489 648.146 19.5049 648.908 20.4358C651.652 23.7887 655.838 24.4317 657.472 24.5928"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M660.917 27.9035C661.054 28.5329 661.592 31.2462 660.002 33.9219C657.894 37.4729 653.879 37.8775 653.48 37.9101"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M649.259 41.267C644.72 43.8443 643.352 46.4445 642.946 48.3499C642.295 51.4045 644.104 52.7106 643.553 56.7567C643.381 58.0303 642.854 61.9195 639.587 64.3186C636.177 66.8199 632.112 65.9876 631.316 65.8089"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M622.25 63.9855C623.838 65.1135 626.555 67.3652 628.59 71.1023C629.534 72.8464 632.209 77.9571 630.802 84.4501C629.404 90.8939 624.925 94.4153 623.726 95.3324C620.624 97.6968 617.511 98.5693 615.748 98.9197"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M615.132 106.834C612.789 107.067 608.231 107.889 604.188 111.299C602.469 112.74 599.565 115.186 599.221 119.001C599.099 120.331 599.331 121.455 599.551 122.209"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M607.62 129.5C607.744 129.72 608.961 132.041 607.783 134.488C606.906 136.292 605.062 137.464 603.006 137.532"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M593.195 134.843C589.335 139.368 585.998 140.521 583.624 140.706C580.958 140.91 578.556 139.965 576.445 141.604C575.455 142.368 574.39 143.798 574.677 145.105C574.987 146.538 576.622 146.417 578.105 148.211C579.435 149.816 580.153 152.367 579.426 154.605C578.726 156.764 576.919 157.857 575.675 158.61C573.217 160.105 570.793 160.252 569.623 160.252"
                stroke="#259975"
                strokeWidth="3"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <defs>
                <clipPath id="clip0_3055_759">
                    <rect width="816" height="349" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};
